// Spread the co-ordinates into a single array
export var reduceCoordinates = coordinates => {
  return coordinates.reduce((previousValue, currentValue) => [...previousValue, ...currentValue], []);
};
/*
  //   Possible features
  //   Point,
  //   LineString,
  //   LinearRing, //Not defined - Linear ring geometry. Only used as part of polygon; cannot be rendered on its own.
  //   Polygon,
  //   MultiPoint,
  //   MultiLineString,
  //   MultiPolygon,
  //   GeometryCollection
  */

export var extractCoordinates = feature => {
  var featureType = feature.getType();

  if (featureType === 'GeometryCollection') {
    var remap = feature.getGeometries().map(obj => {
      // Recursive call
      return extractCoordinates(obj);
    });
    remap = remap.filter(obj => obj !== undefined);
    return reduceCoordinates(remap);
  }

  if (featureType === 'Point') {
    return [feature.getCoordinates()];
  }

  if (featureType === 'LineString' || featureType === 'MultiPoint') {
    return feature.getCoordinates();
  }

  if (featureType === 'Polygon' || featureType === 'MultiLineString') {
    return reduceCoordinates(feature.getCoordinates());
  }

  if (featureType === 'MultiPolygon') {
    return feature.getCoordinates().reduce((previousValue, currentValue) => [...previousValue, ...reduceCoordinates(currentValue)], []);
  }

  return undefined;
};